import * as React from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "@/context/user";
import buzookaIcon from "@/assets/icons/buzooka-icon-light.svg";
import { LoginForm } from "./login-form";

export default function LoginPage() {
  const { user, isLoading } = React.useContext(UserContext);
  const navigate = useNavigate();

  // Handle redirects based on user authentication status
  React.useEffect(() => {
    if (isLoading) return;

    const searchParams = new URLSearchParams(window.location.search);
    const node = searchParams.get("node");
    const prompt = searchParams.get("prompt");

    // Local storage fallbacks (useful when returning from auth redirect)
    const storedNode = localStorage.getItem("node");
    const storedPrompt = localStorage.getItem("buzooka_prompt");

    if (!user) {
      // Not authenticated - redirect to GitHub auth
      // Only redirect if there's a reason to (like node/prompt params present)
      // or if the user explicitly hit the login page with intent.
      if (node || prompt) {
        window.location.href = `${import.meta.env.VITE_PUBLIC_API_ENDPOINT}/auth/github/authorize`;
      }
    } else {
      // Authenticated - redirect to appropriate page
      if (prompt || storedPrompt) {
        navigate("/chat");
      } else if (node || storedNode) {
        navigate("/new");
      } else {
        navigate("/");
      }
    }
  }, [user, isLoading, navigate]);

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const prompt = searchParams.get("prompt");
    const node = searchParams.get("node");

    if (prompt) {
      localStorage.setItem("buzooka_prompt", prompt);
    }
    if (node) {
      localStorage.setItem("node", node);
    }
  }, []);

  return (
    <div className="relative container grid h-screen flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0 dark:bg-gray-900">
      <div className="relative hidden h-full flex-col bg-muted p-10 text-white lg:flex dark:border-r">
        <div className="absolute inset-0 bg-gray-800" />
        <div className="relative z-20 flex items-center text-lg font-medium">
          <img
            src={buzookaIcon}
            alt="Buzooka"
            height={32}
            className="max-h-8"
          />
          Buzooka
        </div>
        <div className="relative z-20 mt-auto">
          <blockquote className="space-y-2">
            <p className="text-md text-slate-300 italic">
              &ldquo;This platform has completely transformed how we handle our
              business operations&rdquo;
            </p>
            <footer className="text-sm text-slate-400">
              Sofia Davis, Billy
            </footer>
          </blockquote>
        </div>
      </div>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center gap-4 lg:p-8">
          <div className="relative">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
          </div>
          <p className="text-sm text-muted-foreground">
            Checking authentication...
          </p>
        </div>
      ) : (
        <LoginForm />
      )}
    </div>
  );
}
